import * as v from "valibot";

import { INCIDENTS_QUERY } from "@/features/incidents/graphql/incidents-query";
import { Incidents } from "@/features/incidents/incidents";

const searchSchema = v.object({
  page: v.pipe(
    v.optional(v.number(), 1),
    v.minValue(1, "page value minimum is 1."),
  ),
  pageSize: v.pipe(
    v.optional(v.number(), 20),
    v.minValue(10, "pageSize value minimum is 10."),
    v.maxValue(100, "pageSize value maximum is 100."),
  ),
  // filters
  name: v.optional(v.string()),
  category: v.optional(v.array(v.string())),
});

export const Route = createFileRoute({
  component: Incidents,
  loaderDeps: ({ search: { page, pageSize } }) => ({ page, pageSize }),
  loader: ({ context, params, deps }) => {
    if (context.urqlClient) {
      context.urqlClient.query(INCIDENTS_QUERY, {
        organizationId: params.orgId,
        first: deps.pageSize,
        offset: (deps.page - 1) * deps.pageSize,
      });
    }
  },
  validateSearch: searchSchema,
});
